import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { checkIsType } from '@src/framework/workbench/drawer/utils';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { BorderType } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import { IItems } from '../form.interface';
import { GradientType } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';

/**
 * 边框专项。边框区域需要隐藏的设置项。
 * @param model 所选元素
 * @returns
 */
export const getBorderHideItems = (model: IElementBaseModel | IMultiplyModel): IItems => {
    const borderType = model.getBorder?.().getBorderType();
    const canSetArrow = (model as IConnectorModel | IShapeModel | IPictureModel).canSetArrowStyle?.();
    const hideCompound = (borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill)
    || checkIsType(model, UIModelType.TABLE);
    const hideSketch = hideCompound || checkIsType(model, UIModelType.CONNECTOR);
    return {
        [FormItemName.BORDER_WIDTH]: () => checkIsType(model, UIModelType.TABLE)
            || (borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill),
        [FormItemName.BORDER_WIDTH_TEXT]: () => checkIsType(model, UIModelType.TABLE)
            || (borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill),
        [FormItemName.BORDER_COLOR]: () => checkIsType(model, UIModelType.TABLE)
            || borderType !== BorderType.SolidFill,
        [FormItemName.BORDER_COLOR_TEXT]: () => checkIsType(model, UIModelType.TABLE)
            || borderType !== BorderType.SolidFill,
        [FormItemName.BORDER_LINE]: () => checkIsType(model, UIModelType.TABLE)
            || (borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill),
        [FormItemName.BORDER_LINE_TEXT]: () => checkIsType(model, UIModelType.TABLE)
            || (borderType !== BorderType.SolidFill && borderType !== BorderType.GradualFill),
        [FormItemName.BORDER_OPACITY]: () => checkIsType(model, UIModelType.TABLE)
            || borderType !== BorderType.SolidFill,
        [FormItemName.BORDER_ARROW_TEXT]: () => !canSetArrow,
        [FormItemName.BORDER_ARROW_HEAD]: () => !canSetArrow,
        [FormItemName.BORDER_ARROW_TAIL]: () => !canSetArrow,
        [FormItemName.BORDER_ARROW_SIZE_TEXT]: () => !canSetArrow,
        [FormItemName.BORDER_ARROW_SIZE_HEAD]: () => !canSetArrow,
        [FormItemName.BORDER_ARROW_SIZE_TAIL]: () => !canSetArrow,
        [FormItemName.BORDER_SKETCH]: () => hideSketch,
        [FormItemName.BORDER_SKETCH_TEXT]: () => hideSketch,
        [FormItemName.BORDER_SPACE]: () => borderType !== BorderType.SolidFill,
        [FormItemName.BORDER_GRADUAL_LINEAR_GRADIENT]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_RADIAL_GRADIENT]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_RECT_GRADIENT]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_SHAPE_GRADIENT]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_ANGLE]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_DIRECTION]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_TYPE_TEXT]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_ANGLE_TEXT]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_DIRECTION_TEXT]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_BAR]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_GRADUAL_OPACITY]: () => borderType !== BorderType.GradualFill,
        [FormItemName.BORDER_COMPOUND_TYPE]: () => hideCompound,
        [FormItemName.BORDER_COMPOUND_TYPE_TEXT]: () => hideCompound,
    };
};
